<app-loader [Parent]="this"></app-loader>
<div [formGroup]="Form" *ngIf="FormLoaded">
  <app-pageheader [Parent]="this">
    <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()"></app-form-save-button>
    @if (!ModelIsNew) {
      <app-form-delete-button [Parent]="this" [Form]="Form" [ModelId]="ModelId" [Model]="Model"
        DeleteUrl="payments/transactionbreakdown/feetypes/" [DeleteCheck]="true" Api="payments/transactionbreakdown"
        TypeName="TransactionFeeType" DeleteNavLink="/revenue/transactionbreakdown" Title="Fee Type">
      </app-form-delete-button>
    }
  </app-pageheader>
  <div class="columns">
    <div class="column is-6">
      <article class="panel">
        <p class="panel-heading">Fee Type</p>
        <div class="panel-block is-block">
          <app-field Label="Name">
            <div class="control">
              <input formControlName="Name" class="input" type="text" placeholder="e.g. Tax, City Surcharge" />
              <app-validator [For]="Form.get('Name')"></app-validator>
            </div>
          </app-field>
          <app-field Label="Stage">
            <div class="control select is-fullwidth">
              <select formControlName="Stage">
                <option [ngValue]="100">Pre-tax Fee (applied before taxes, included in the taxable amount)</option>
                <option [ngValue]="200">Tax</option>
                <option [ngValue]="300">Post-tax Fee (applied after taxes, e.g. a payment fee)</option>
              </select>
            </div>
          </app-field>
          <app-field Label="Value Kind">
            <div class="control select is-fullwidth">
              <select formControlName="ValueKind">
                <option [ngValue]="0">Percentage</option>
                <option [ngValue]="1">Flat Amount</option>
              </select>
            </div>
          </app-field>
          @if (Form.get('ValueKind')?.value == 0) {
            <app-field Label="Percentage Basis">
              <div class="control select is-fullwidth">
                <select formControlName="Basis">
                  <option [ngValue]="0">Base Parking Amount (independent of other fees)</option>
                  <option [ngValue]="1">Stage Running Total (base plus everything applied in earlier stages)</option>
                </select>
              </div>
            </app-field>
          }
        </div>
      </article>
    </div>
  </div>
</div>
